import React, { useState } from "react";
import SpecialOffers from "../../components/home/SpecialOffers/SpecialOffers";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import BestSellers from "../../components/home/BestSellers/BestSellers";

const Offer = () => {
  const [prevLocation] = useState("");

  return (
    <div className="max-w-container mx-auto">
      
      <div
        className="relative w-full h-[400px] bg-cover bg-center"
        style={{
          backgroundImage: `url(${require("../../assets/images/products/productOfTheYear.jpg")})`, // Replace with your offer image path
        }}
      >
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <h1 className="text-4xl font-bold text-white">Special Offers</h1>
        </div>
      </div>

     <div style={{marginLeft:'30px',marginRight:'30px'}}>
      <Breadcrumbs title="Offer" prevLocation={prevLocation} />

      <div className="pb-10">
        <SpecialOffers />
        <BestSellers />
      </div>
      </div>
    </div>
  );
};

export default Offer;
